import { GanttConfig } from '../GanttConfig';
import { differenceInSeconds } from 'date-fns';
import { PartialTimelineNode } from './generateQueues';
import { ScaleFilter } from '../components/Timeline/TimelineFilterChip';

export const calculateNodeWidth = (
  currentFilter: ScaleFilter,
  { startDate, endDate }: Pick<PartialTimelineNode, 'startDate' | 'endDate'>,
) => {
  const secondsDiff = differenceInSeconds(endDate, startDate);
  const hoursDifference = secondsDiff / 3600;
  const scaleFactor = GanttConfig.SINGLE_ELEMENT_WIDTH / currentFilter.measureScale;
  const nodeWidth = hoursDifference * scaleFactor;

  return nodeWidth;
};
